<template>
    <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 32 32" fill="none">
        <path d="M32 0H0V32H32V0Z" fill="white" fill-opacity="0.01"/>
        <path d="M5.29985 7.96655H26.6332" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.29985 15.9666H26.6332" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.29985 23.9666H26.6332" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
